import { media } from "./manager/media/media";
import { reports } from "./manager/reports";
import { analytics } from "./manager/analytics";
import { authentication } from "./manager/authentication";
import { user } from "./manager/user/user";
import { billing } from "./manager/billing";
import player from "./manager/player/player";
import { system } from "./manager/system/system";

export default sdk => ({
  flavor: "bs.vidaa",
  mediaManager: Object.assign(sdk, media),
  reportsManager: Object.assign(sdk, reports),
  analyticsManager: Object.assign(sdk, analytics),
  authenticationManager: Object.assign(sdk, authentication),
  playerManager: Object.assign(sdk, player),
  userManager: Object.assign(sdk, user),
  systemManager: Object.assign(sdk, system),
  billingManager: Object.assign(sdk, billing)
});
